export default function RevAd({ id }) {
  return <div data-ad={id} />;
}
